import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'site-modules/shared/components/link/link';

import './shopping-link.scss';

export function ShoppingLink({
  linkTag: LinkTag = Link,
  label,
  description = null,
  creativeId = null,
  className = 'rounded mx-0 px-1 py-0_75',
  descriptionClassName = null,
  iconClassName = null,
  iconContainerClassName = 'align-self-start me-0_75 size-16 text-blue-50',
  iconStyles = {
    height: '36px',
    width: '36px',
  },
  labelClassName = 'text-gray-darkest fw-bold',
  arrowClassName = 'icon-arrow-right3 text-primary-darker medium',
  isDescriptionBelow = false,
  linkContainerClassName,
  icon,
  styles,
  ...linkProps
}) {
  const descriptionFragment = !!description && <div className={descriptionClassName}>{description}</div>;

  return (
    <div
      className={classnames('shopping-link text-decoration-none pos-r', className)}
      style={styles}
      data-tracking-parent={creativeId}
    >
      <div className="d-flex align-items-center w-100">
        {icon || (
          <i
            className={classnames(
              'link-icon d-flex align-items-center justify-content-center',
              iconClassName,
              iconContainerClassName
            )}
            style={{ ...iconStyles, flexShrink: 0 }}
            aria-hidden
          />
        )}
        <div className={classnames('pe-0_5', linkContainerClassName)}>
          <LinkTag {...linkProps} className={classnames('label-text no-focus', labelClassName)}>
            {label}
          </LinkTag>
          {!isDescriptionBelow && descriptionFragment}
        </div>
        <div className="px-0 d-flex justify-content-end justify-content-md-between align-items-center ms-auto">
          <i className={arrowClassName} aria-hidden />
        </div>
      </div>
      {isDescriptionBelow && descriptionFragment}
    </div>
  );
}

ShoppingLink.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  linkTag: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.elementType]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  creativeId: PropTypes.string,
  className: PropTypes.string,
  descriptionClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  iconStyles: PropTypes.objectOf(PropTypes.string),
  labelClassName: PropTypes.string,
  arrowClassName: PropTypes.string,
  isDescriptionBelow: PropTypes.bool,
  icon: PropTypes.node,
  styles: PropTypes.shape({}),
  linkContainerClassName: PropTypes.string,
};
